import { motion } from "framer-motion";

export const Marquee = () => {
  const text = "DR. YAGO ALMEIDA \u00b7 Cirurgia Plástica \u00b7 ";
  const repeated = text.repeat(10);

  return (
    <div className="bg-navy py-4 overflow-hidden" data-testid="marquee">
      <div className="marquee-track animate-marquee">
        <span className="font-body text-white/20 text-sm tracking-[0.3em] uppercase whitespace-nowrap">
          {repeated}
        </span>
        <span className="font-body text-white/20 text-sm tracking-[0.3em] uppercase whitespace-nowrap">
          {repeated}
        </span>
      </div>
    </div>
  );
};
